import type { InternalAppType } from "types/branding";

export const AUDIENCE_APP_URLS: Record<"dev" | "prod", Record<InternalAppType, string>> = {
  dev: {
    forsler: "https://dev.forsler.com",
    skovkortet: "https://dev.forsler.com",
    george: "https://georgemaps-dev.web.app",
  },
  prod: {
    forsler: "https://app.forsler.com",
    skovkortet: "https://skovkortet.forsler.com",
    george: "https://app.georgemaps.io",
  },
};

